var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('vue-meeting-selector',{staticClass:"simple-example__meeting-selector",attrs:{"calendar-options":{
        daysLabel:[
            'Dim.',
            'Lun.',
            'Mar.',
            'Mer.',
            'Jeu.',
            'Ven.',
            'Sam.' ],
        monthsLabel:[
            'Jan.',
            'Fév.',
            'Mar.',
            'Avr.',
            'Mai.',
            'Jun.',
            'Juil.',
            'Août.',
            'Sep.',
            'Oct.',
            'Nov.',
            'Déc.' ]
      },"date":_vm.date,"loading":_vm.loading,"class-names":_vm.classNames,"meetings-days":_vm.meetingsDays},on:{"next-date":_vm.nextDate,"previous-date":_vm.previousDate},model:{value:(_vm.meeting),callback:function ($$v) {_vm.meeting=$$v},expression:"meeting"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }